const ElDialog = ELEMENT.Dialog;

ElDialog.props.appendToBody = {
  type: null,
  default: false
};

ElDialog.computed.appendToDom = function () {
  let appendToBody = this.appendToBody;
  if (appendToBody === false) {
    return null;
  }
  if (appendToBody && appendToBody.appendChild) {
    return appendToBody;
  }
  return document.body;
};

ElDialog.watch.visible = function (val) {
  if (val) {
    this.closed = false;
    this.$emit("open");
    this.$el.addEventListener("scroll", this.updatePopper);
    this.$nextTick(() => {
      this.$refs.dialog.scrollTop = 0;
    });
    if (this.appendToDom) {
      this.appendToDom.appendChild(this.$el);
    }
  } else {
    this.$el.removeEventListener("scroll", this.updatePopper);
    if (!this.closed) this.$emit("close");
    if (this.destroyOnClose) {
      this.$nextTick(() => {
        this.key++;
      });
    }
  }
};

ElDialog.mounted = function () {
  if (this.visible) {
    this.rendered = true;
    this.open();
    if (this.appendToDom) {
      this.appendToDom.appendChild(this.$el);
    }
  }
};

ElDialog.destroyed = function () {
  // if appendToBody is true, remove DOM node after destroy
  if (this.appendToDom && this.$el && this.$el.parentNode && this.appendToDom.contains(this.$el)) {
    try {
      this.appendToDom.removeChild(this.$el);
    } catch (ex) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
